import { render } from "./ViewCommandeFournisseurPage.vue?vue&type=template&id=c09c1136&ts=true"
import script from "./ViewCommandeFournisseurPage.vue?vue&type=script&lang=ts"
export * from "./ViewCommandeFournisseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__